import { forwardRef, memo } from 'react';
import { Filter as FilterIcon } from 'react-feather';
import styled from '@emotion/styled';
import { css } from '@emotion/react';

type Props = {
  className?: string;
  iconClassName?: string;
  disabled?: boolean;
  isActive: boolean;
};

export const FilterIconButton = memo(
  forwardRef<HTMLDivElement, Props>(({ className, iconClassName, disabled, isActive }, ref) => {
    return (
      <div ref={ref} className={className}>
        <StyledFilterIcon size={20} className={iconClassName} isActive={isActive} disabled={disabled} />
      </div>
    );
  })
);

FilterIconButton.displayName = 'ProjectClips.FilterIconButton';

const StyledFilterIcon = styled(FilterIcon)<{ isActive: boolean; disabled?: boolean }>`
  color: var(--black-l);
  margin-top: 4px;
  cursor: pointer;

  ${({ isActive }) =>
    isActive &&
    css`
      fill: var(--black-l);
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      fill: var(--gray);
      cursor: default;
    `}
`;
